import {
  Box,
  Button,
  CircularProgress,
  IconButton,
  TextField,
  Typography
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const CouponSection = ({
  couponCode,
  setCouponCode,
  couponError,
  couponLoading,
  appliedCoupon,
  discountedPrice,
  validateAndApplyCoupon,
  removeCoupon,
  isAnnual,
  isButtonDisabled
}) => {
  return (
    <Box sx={{ mb: 3 }}>
      {!appliedCoupon && (
        <Typography
          sx={{
            fontSize: 'var(--font-size-14)',
            fontWeight: 500,
            color: 'var(--color-text-dark)',
            mb: 1
          }}
        >
          Have a coupon code?
        </Typography>
      )}

      <Box>
        <Box
          sx={{
            display: 'flex',
            gap: 1,
            alignItems: 'flex-start',
            flexDirection: { xs: 'column', sm: 'row' }
          }}
        >
          <TextField
            key="coupon-text-field" // helps React track this input
            size="small"
            placeholder="Enter coupon code"
            value={couponCode}
            onChange={(e) => setCouponCode(e.target.value)}
            error={!!couponError}
            helperText={couponError}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                validateAndApplyCoupon();
              }
            }}
            sx={{
              flex: 1,
              '& .MuiOutlinedInput-root': {
                height: '40px',
                borderRadius: '6px'
              }
            }}
            disabled={appliedCoupon || isButtonDisabled}
          />
          <Button
            variant="outlined"
            size="small"
            onClick={() => {
              if (appliedCoupon) {
                removeCoupon();
              } else {
                validateAndApplyCoupon();
              }
            }}
            disabled={isButtonDisabled || couponLoading || !couponCode?.trim()}
            sx={{
              height: '40px',
              minWidth: '80px',
              textTransform: 'none'
            }}
          >
            {couponLoading ? (
              <CircularProgress size={16} />
            ) : appliedCoupon ? (
              'Cancel'
            ) : (
              'Apply'
            )}
          </Button>
        </Box>

        {appliedCoupon && (

          <Box
            sx={{
              mt: 2,
              p: 2,
              backgroundColor: 'var(--color-bg-mint)',
              border: '1px solid #BBF7D0',
              borderRadius: '8px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'flex-start'
            }}
          >
            <Box>
              <Typography
                sx={{
                  fontSize: 'var(--font-size-16)',
                  fontWeight: 600,
                  color: 'var(--color-success-green)',
                  mb: 0.5
                }}
              >
                Coupon Applied: {appliedCoupon}
              </Typography>
              <Box>
                <Typography
                  sx={{
                    fontSize: 'var(--font-size-14)',
                    lineHeight: 'var(--line-height-20)',
                    fontWeight: 500,
                    color: 'var(--color-success-green)'
                  }}
                >
                  Success! A discount of {discountedPrice?.savings?.percentage || 25}% has been applied to your order.
                </Typography>
              </Box>

            </Box>
            <IconButton
              size="small"
              onClick={removeCoupon}
              sx={{ color: 'var(--color-success-green)' }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default CouponSection;
